module.exports = __webpack_public_path__ + "static/media/ZSBS05.cbcfa7e5.jpg";